"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
exports.isError = function (response) {
    return response.error !== undefined;
};
//# sourceMappingURL=isError.js.map